module.exports = __webpack_public_path__ + "static/media/splash_tour_logo_color.aa1ac224.png";